module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/grapesjs/dist/fonts/fontawesome-webfont.eot
// module id = ../../../../grapesjs/dist/fonts/fontawesome-webfont.eot
// module chunks = 2